var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login page"},[_c('forgetPassword',{attrs:{"title":"Quên mật khẩu"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }